<template>
  <seckill-popup class="seckill-rule-popup-component"
                 :show.sync="visible"
                 title="限时秒杀规则"
  >
    <div class="seckill-rule-popup-content"
         v-html="rule"
    ></div>
  </seckill-popup>
</template>

<script>
  import SeckillPopup from '@/pages/Seckill/components/SeckillPopup';

  export default {
    name: 'SeckillRulePopup',
    components: {
      SeckillPopup,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      rule: {
        type: String,
        required: true,
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .seckill-rule-popup {
    &-content {
      padding: @size-extra-medium @size-base;
      font-size: @font-size-base;
      color: @color-text-light;
    }
  }
</style>
